module.exports = __webpack_public_path__ + "static/media/icon_148.725d6068.svg";